// openEHR AM model — BMM package org.openehr.am.aom2.persistence.terminology
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import * as openehr_base from "../../../base/mod.ts";

/**
 * Local ontology of an archetype.
 */
export class P_ARCHETYPE_TERMINOLOGY {
  /**
   * Internal storage for is_differential
   * @protected
   */
  protected _is_differential?: openehr_base.Boolean;

  get is_differential(): boolean | undefined {
    return this._is_differential?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for is_differential.
   * Use this to access openehr_base.Boolean methods.
   */
  get $is_differential(): openehr_base.Boolean | undefined {
    return this._is_differential;
  }

  /**
   * Sets is_differential from either a primitive value or openehr_base.Boolean wrapper.
   */
  set is_differential(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._is_differential = undefined;
    } else if (typeof val === "boolean") {
      this._is_differential = openehr_base.Boolean.from(val);
    } else {
      this._is_differential = val;
    }
  }

  /**
   * Internal storage for original_language
   * @protected
   */
  protected _original_language?: openehr_base.String;

  get original_language(): string | undefined {
    return this._original_language?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for original_language.
   * Use this to access openehr_base.String methods.
   */
  get $original_language(): openehr_base.String | undefined {
    return this._original_language;
  }

  /**
   * Sets original_language from either a primitive value or openehr_base.String wrapper.
   */
  set original_language(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._original_language = undefined;
    } else if (typeof val === "string") {
      this._original_language = openehr_base.String.from(val);
    } else {
      this._original_language = val;
    }
  }

  /**
   * Directory of term definitions as a two-level
   * table. The outer hash keys are term codes,
   * e.g. "at0004", and the inner hash key are term
   * attribute names, e.g. "text", "description" etc.
   */
  term_definitions?: undefined;
  /**
   * Directory of term bindings as a two-level
   * table. The outer hash keys are local term codes,
   * e.g. "at0004", and the inner hash keys are terminology
   * code phrases, e.g. "SNOMED(2003)::163034007" etc.
   */
  term_bindings?: undefined;
  value_sets?: undefined;
}
